const basicObjectMapper = (dataObj: { [key: string]: any }) => (mapper: any) =>
  Object.entries(dataObj).reduce(mapper, {});

export default basicObjectMapper;
